import { getEmploymentData } from '~/data/employee';
import { useArraySWR } from '~/hooks/useSWR';

export const useEmploymentData = (props: { employeeId: number }) => {
  const { employeeId } = props;
  return useArraySWR(['employmentData', employeeId], () =>
    getEmploymentData(employeeId),
  );
};
